import InteractiveAnnotation from "./interactiveAnnotation";
import SegmentChain from "./segmentChain";
import { setBoxStyle } from "../canvasUtils";

export default class ContinuousDraw extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);
    this.chains = [];
    this.activeChain = null;

    this.min = { x: position.x - 5, y: position.y - 5 };
    this.max = { x: position.x + 5, y: position.y + 5 };

    this.active = false;
    this.drawingInitialLines = true;
    this.isContinuous = true;
  }

  draw(ctx) {
    for (var i = 0; i < this.chains.length; i++)
      this.chains[i].draw(ctx);

    if (this.active && !this.drawingInitialLines)
      this.drawBoundingBox(ctx);
  }

  drawBoundingBox(ctx) {
    setBoxStyle(ctx);
    let x = this.min.x;
    let y = this.min.y;
    let width = this.max.x - this.min.x;
    let height = this.max.y - this.min.y;
    ctx.strokeRect(x, y, width, height);
  }

  isInBounds(x, y) {
    return x >= this.min.x && x <= this.max.x
      && y >= this.min.y && y <= this.max.y;
  }

  mousedown(x, y) {
    if (this.drawingInitialLines) {
      this.activeChain = new SegmentChain({x, y}, this.options);
      this.chains.push(this.activeChain);
      this.activeChain.mousedown(x, y);
    } else
      for (var i = 0; i < this.chains.length; i++)
        this.chains[i].mousedown(x, y);
    this.syncMinMax();
    this.active = true;
    this.signalReady();
  }

  mousemove(x, y) {
    if (this.drawingInitialLines)
      this.activeChain && this.activeChain.mousemove(x, y);
    else
      for (var i = 0; i < this.chains.length; i++)
        this.chains[i].mousemove(x, y);
    this.syncMinMax();
    this.signalReady();
  }

  mouseup() {
    this.activeChain = null;
    for (var i = 0; i < this.chains.length; i++)
      this.chains[i].deactivate();
    this.syncMinMax();
    this.signalReady();
  }

  deactivate() {
    this.activeChain = null;
    for (var i = 0; i < this.chains.length; i++)
      this.chains[i].deactivate();
    this.drawingInitialLines = false;
    this.isContinuous = false;
    this.active = false;
    this.signalReady();
  }

  syncMinMax() {
    if (this.chains.length) {
      this.min = { ...this.chains[0].min };
      this.max = { ...this.chains[0].max };
      for (var i = 1; i < this.chains.length; i++) {
        let c = this.chains[i];
        this.min.x = Math.min(this.min.x, c.min.x);
        this.min.y = Math.min(this.min.y, c.min.y);
        this.max.x = Math.max(this.max.x, c.max.x);
        this.max.y = Math.max(this.max.y, c.max.y);
      }
    }
  }

  setLineWidth(width) {
    for (var i = 0; i < this.chains.length; i++) 
      this.chains[i].setLineWidth(width);
      this.signalReady();
  }

  updateColor(color) 
  {
    for (var i = 0; i < this.chains.length; i++) 
      this.chains[i].color = color;;
    this.color = color;
  }
}